export default __webpack_public_path__ + "components/weather-icon/static/dayheavysnow@3-3781fa9ec2cdc7552b381dc6ecc24f57.png";